import { render, staticRenderFns } from "./ArticleContent.vue?vue&type=template&id=57740539&"
import script from "./ArticleContent.vue?vue&type=script&lang=js&"
export * from "./ArticleContent.vue?vue&type=script&lang=js&"
import style0 from "./ArticleContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports